/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Carriers API
 * Carrier-facing API for the carrier portal (carriers.freightsimple.com).  Authentication: a carrier opens a permanent signed login link, exchanges it for a session token, and presents that token as a bearer on every other call. `CarrierPortalAuthenticationFilter` validates the session and scopes each request to one carrier. Operations use `security: []` (no Micronaut JWT) — the filter is the authenticator, the same model the agents API uses.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface SessionResponse
 */
export interface SessionResponse {
  /**
   *
   * @type {string}
   * @memberof SessionResponse
   */
  sessionToken: string;
  /**
   *
   * @type {string}
   * @memberof SessionResponse
   */
  carrierIdentifier: string;
  /**
   *
   * @type {string}
   * @memberof SessionResponse
   */
  carrierName: string;
  /**
   *
   * @type {string}
   * @memberof SessionResponse
   */
  userName: string;
  /**
   *
   * @type {string}
   * @memberof SessionResponse
   */
  userEmail: string;
}

/**
 * Check if a given object implements the SessionResponse interface.
 */
export function instanceOfSessionResponse(
  value: object,
): value is SessionResponse {
  if (!("sessionToken" in value) || value["sessionToken"] === undefined)
    return false;
  if (
    !("carrierIdentifier" in value) ||
    value["carrierIdentifier"] === undefined
  )
    return false;
  if (!("carrierName" in value) || value["carrierName"] === undefined)
    return false;
  if (!("userName" in value) || value["userName"] === undefined) return false;
  if (!("userEmail" in value) || value["userEmail"] === undefined) return false;
  return true;
}

export function SessionResponseFromJSON(json: any): SessionResponse {
  return SessionResponseFromJSONTyped(json, false);
}

export function SessionResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): SessionResponse {
  if (json == null) {
    return json;
  }
  return {
    sessionToken: json["sessionToken"],
    carrierIdentifier: json["carrierIdentifier"],
    carrierName: json["carrierName"],
    userName: json["userName"],
    userEmail: json["userEmail"],
  };
}

export function SessionResponseToJSON(json: any): SessionResponse {
  return SessionResponseToJSONTyped(json, false);
}

export function SessionResponseToJSONTyped(
  value?: SessionResponse | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    sessionToken: value["sessionToken"],
    carrierIdentifier: value["carrierIdentifier"],
    carrierName: value["carrierName"],
    userName: value["userName"],
    userEmail: value["userEmail"],
  };
}
